<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-call">
<h1>The Call</h1>
<p style="text-indent:0em !important">No one heard the scream that left</p>
<p style="text-indent:0em !important">my lungs today.</p>
<p style="text-indent:0em !important">It couldn’t travel much.</p>
<p style="text-indent:0em !important">The air around me said,</p>
<p style="text-indent:0em !important"><em>Things that heavy</em></p>
<p style="text-indent:0em !important"><em>only belong to the ground</em>,</p>
<p style="text-indent:0em !important">but I wonder if you knew it took</p>
<p style="text-indent:0em !important">the shape of</p>
<p style="text-indent:0em !important">your name.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?0ee57530